/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientDto
 */
export interface PatientDto {
    /**
     * Patient ID
     * @type {string}
     * @memberof PatientDto
     */
    patientId: string;
    /**
     * Patient first name
     * @type {string}
     * @memberof PatientDto
     */
    firstName: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof PatientDto
     */
    lastName: string;
    /**
     * Patient gender
     * @type {string}
     * @memberof PatientDto
     */
    gender: string;
    /**
     * Patient birth date
     * @type {Date}
     * @memberof PatientDto
     */
    birthDate: Date;
    /**
     * Patient middle name
     * @type {string}
     * @memberof PatientDto
     */
    middleName: string;
    /**
     * Patient photo URL
     * @type {string}
     * @memberof PatientDto
     */
    photoUrl: string;
    /**
     * Patient extensions
     * @type {Array<string>}
     * @memberof PatientDto
     */
    extension: Array<string>;
    /**
     * Patient email
     * @type {string}
     * @memberof PatientDto
     */
    email: string;
    /**
     * Patient phone
     * @type {string}
     * @memberof PatientDto
     */
    phone: string;
    /**
     * Patient status
     * @type {string}
     * @memberof PatientDto
     */
    status: string;
    /**
     * Is patient in provider's contact list
     * @type {boolean}
     * @memberof PatientDto
     */
    isInContactList: boolean;
    /**
     * Patient full name
     * @type {string}
     * @memberof PatientDto
     */
    fullName: string;
}

/**
 * Check if a given object implements the PatientDto interface.
 */
export function instanceOfPatientDto(value: object): value is PatientDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('middleName' in value) || value['middleName'] === undefined) return false;
    if (!('photoUrl' in value) || value['photoUrl'] === undefined) return false;
    if (!('extension' in value) || value['extension'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isInContactList' in value) || value['isInContactList'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function PatientDtoFromJSON(json: any): PatientDto {
    return PatientDtoFromJSONTyped(json, false);
}

export function PatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'gender': json['gender'],
        'birthDate': (new Date(json['birthDate'])),
        'middleName': json['middleName'],
        'photoUrl': json['photoUrl'],
        'extension': json['extension'],
        'email': json['email'],
        'phone': json['phone'],
        'status': json['status'],
        'isInContactList': json['isInContactList'],
        'fullName': json['fullName'],
    };
}

export function PatientDtoToJSON(json: any): PatientDto {
    return PatientDtoToJSONTyped(json, false);
}

export function PatientDtoToJSONTyped(value?: PatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'gender': value['gender'],
        'birthDate': ((value['birthDate']).toISOString()),
        'middleName': value['middleName'],
        'photoUrl': value['photoUrl'],
        'extension': value['extension'],
        'email': value['email'],
        'phone': value['phone'],
        'status': value['status'],
        'isInContactList': value['isInContactList'],
        'fullName': value['fullName'],
    };
}

